import { assetRef } from '../../config/src/commons';

export default [
  {
    name: 'JavaScript',
    logo: assetRef('lang/js.svg'),
  },
  {
    name: 'TypeScript',
    logo: assetRef('lang/ts.svg'),
  },
  {
    name: 'Alpine',
    logo: assetRef('lib/alpine.png'),
  },
  {
    name: 'Angular',
    logo: assetRef('lib/angular.svg'),
  },
  {
    name: 'Astro',
    logo: assetRef('lib/astro.svg'),
  },
  {
    name: 'React',
    logo: assetRef('lib/react.svg'),
  },
  {
    name: 'React Native',
    logo: assetRef('lib/react-native.png'),
  },
  {
    name: 'Vue',
    logo: assetRef('lib/vuejs.svg'),
  },
  {
    name: 'Lit',
    logo: assetRef('lib/lit.svg'),
  },
  {
    name: 'FAST',
    logo: assetRef('lib/fast.svg'),
  },
  {
    name: 'Svelte',
    logo: assetRef('lib/svelte.svg'),
  },
  {
    name: 'Preact',
    logo: assetRef('lib/preact.svg'),
  },
  {
    name: 'Stencil',
    logo: assetRef('lib/stencil.svg'),
  },
  {
    name: 'Solid',
    logo: assetRef('lib/solid.svg'),
  },
  {
    name: 'Omi',
    logo: assetRef('lib/omi.png'),
  },
  {
    name: 'Tailwindcss',
    logo: assetRef('lib/tailwindcss.svg'),
  },
  {
    name: 'Sass',
    logo: assetRef('lang/sass.svg'),
  },
  {
    name: 'Less',
    logo: assetRef('lang/less.svg'),
  },
  {
    name: 'Markdown',
    logo: assetRef('lang/markdown.svg'),
  },
  {
    name: 'MDX',
    logo: assetRef('lang/mdx.svg'),
  },
  {
    name: 'Storybook',
    logo: assetRef('lib/storybook.svg'),
  },
  {
    name: 'System UI',
    logo: assetRef('lib/system-ui.svg'),
  },
  {
    name: 'Style Dictionary',
    logo: assetRef('lib/style-dictionary.png'),
  },
  {
    name: 'Styled Components',
    logo: assetRef('lib/styled-components.png'),
  },
  {
    name: 'Open Props',
    logo: assetRef('lib/open-props.svg'),
  },
  {
    name: 'Twind',
    logo: assetRef('lib/twind.png'),
  },
  {
    name: 'CSS Modules',
    logo: assetRef('lib/css-modules.png'),
  },
  {
    name: 'Emotion',
    logo: assetRef('lib/emotion.png'),
  },
  {
    name: 'Mithril',
    logo: assetRef('lib/mithril.svg'),
  },
  {
    name: 'NextJS',
    logo: assetRef('lib/nextjs.svg'),
  },
  {
    name: 'Nuxt',
    logo: assetRef('lib/nuxt.svg'),
  },
  {
    name: 'Nunjucks',
    logo: assetRef('lib/nunjucks.svg'),
  },
  {
    name: 'LWC',
    logo: assetRef('lib/lwc.svg'),
  },
  {
    name: 'Riotjs',
    logo: assetRef('lib/riotjs.svg'),
  },
  {
    name: 'WASM',
    logo: assetRef('lang/wasm.svg'),
  },
  {
    name: 'Many more',
    logo: assetRef('icons/code.svg'),
  },
  // {
  //   name: 'git',
  //   logo: assetRef('logo/git.svg'),
  // },
  // {
  //   name: 'github',
  //   logo: assetRef('logo/github.svg'),
  // },
  // {
  //   name: 'gitlab',
  //   logo: assetRef('logo/gitlab.svg'),
  // },
  // {
  //   name: 'npm',
  //   logo: assetRef('logo/npm.svg'),
  // },
  // {
  //   name: 'netlify',
  //   logo: assetRef('logo/netlify.svg'),
  // },
];
